import pick from 'object.pick';
import {stringify} from 'qs';

import {get} from '@stubhub/rest-method';

import SearchInventoryV2Interface from './interface';

const LISTING_PATH = '/search/inventory/v2/listings';

const defaults = {
  additionalPricingInfo: false,
  allSectionZoneStats: false,
  edgeControlEnabled: true,
  eventLevelStats: false,
  eventPricingSummary: true,
  listingAttributeCategorySummary: false,
  pricingSummary: true,
  quantitySummary: false,
  sectionStats: true,
  shstore: 1,
  start: 0,
  urgencyMessaging: false,
  valuePercentage: false,
  zoneStats: true,
  scoreVersion: 'v2',
};

function getPriceType(search) {
  if (search.priceType) {
    return search.priceType;
  }

  return search.priceWithFees ? 'bundledPrice' : 'nonBundledPrice';
}

function getInventoryListingUrl(search, opts) {
  const queryParams = {
    ...getBaseQueryParams(opts),
    ...search,
    priceType: getPriceType(search),
  };

  return `${LISTING_PATH}?${stringify(queryParams)}`;
}

function getBaseQueryParams(opts) {
  return {
    ...defaults,
    ...pick(opts, Object.keys(defaults)),
  };
}

const MAX_TIMEOUT = 10000; // Setting to max timeout 10 seconds

export default function SearchInventoryV2(opts = {}) {
  return {
    get: async ({headers: requestHeaders, logger, ...args}) => {
      const headers = {
        'Accept-Language': opts.lang || 'en-US',
        Authorization: process.env.REACT_APP_API_SECRET,
        ...requestHeaders,
      };

      const defaults = {
        host: process.env.REACT_APP_API_HOST,
        path: getInventoryListingUrl(args, opts),
        headers,
        json: true,
        logger,
        timeout: opts.timeout || MAX_TIMEOUT,
      };

      const resultingConfig = {...defaults, ...args};

      return await get(resultingConfig).then(SearchInventoryV2Interface);
    },
  };
}
